document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".custom-filtered-blocks");

  sections.forEach((section) => {
    const filtersContainer = section.querySelector(".custom-filtered-blocks__filters");
    const buttons = section.querySelectorAll(".filter-btn");
    const items = Array.from(section.querySelectorAll(".custom-filtered-blocks__block"));
    const loadMoreBtn = section.querySelector(".custom-filtered-blocks__load-more-btn");

    if (!items.length) return;

    const desktopCount = parseInt(section.dataset.desktopCount) || 6;
    const mobileCount = parseInt(section.dataset.mobileCount) || 3;

    const isMobile = window.innerWidth < 768;
    const initialCount = isMobile ? mobileCount : desktopCount;

    let currentFilter = "all";
    let visibleCount = initialCount;

    function updateView() {
      let visibleIndex = 0;

      const filteredItems = items.filter((item) => {
        const itemFilter = item.dataset.filterTrigger;
        return currentFilter === "all" || itemFilter === currentFilter;
      });

      items.forEach((item) => {
        const itemFilter = item.dataset.filterTrigger;
        const shouldBeVisible = (currentFilter === "all" || itemFilter === currentFilter) && filteredItems.indexOf(item) < visibleCount;

        const wasHidden = item.style.display === "none";

        if (shouldBeVisible) {
          item.style.display = "flex";

          if (wasHidden) {
            item.classList.add("is-enter");
            item.style.transitionDelay = `${visibleIndex * 40}ms`;

            requestAnimationFrame(() => {
              item.classList.remove("is-enter");
            });
          }

          visibleIndex++;
        } else {
          item.style.display = "none";
          item.style.transitionDelay = "0ms";
        }
      });

      if (loadMoreBtn) {
        if (visibleCount >= filteredItems.length) {
          loadMoreBtn.style.display = "none";
        } else {
          loadMoreBtn.style.display = "flex";
        }
      }
    }

    if (filtersContainer && buttons.length) {
      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          currentFilter = button.dataset.filter;

          buttons.forEach((btn) => btn.classList.remove("is-active"));
          button.classList.add("is-active");

          visibleCount = initialCount;

          updateView();
        });
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", () => {
        visibleCount += initialCount;
        updateView();
      });
    }

    updateView();
  });
});
